import { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../api/authPasswordApi";

const GENERIC_SUCCESS_MESSAGE =
  "If an account exists for that email, password reset instructions have been sent.";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) {
      setErrorMessage("Email is required.");
      return;
    }

    try {
      setSubmitting(true);
      const body = await requestPasswordReset(normalizedEmail);
      setSuccessMessage(body?.message || GENERIC_SUCCESS_MESSAGE);
    } catch (error) {
      if (error.status === 429) {
        setErrorMessage(error.message);
      } else {
        setSuccessMessage(GENERIC_SUCCESS_MESSAGE);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="midpoint-app auth-page">
      <div className="auth-login-card panel-card">
        <p className="eyebrow">Midpoint</p>
        <h1>Forgot password</h1>
        <p className="muted">
          Enter your email and we will send reset instructions if an account exists.
        </p>

        {successMessage ? (
          <p className="auth-login-message" role="status">
            {successMessage}
          </p>
        ) : (
          <form className="auth-login-form" onSubmit={handleSubmit}>
            <label>
              <span>Email</span>
              <input
                type="email"
                name="email"
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                disabled={submitting}
                required
              />
            </label>

            {errorMessage ? (
              <p className="auth-login-error" role="alert">
                {errorMessage}
              </p>
            ) : null}

            <button
              type="submit"
              className="report-submit-cta auth-login-submit"
              disabled={submitting}
            >
              {submitting ? "Sending…" : "Send reset instructions"}
            </button>
          </form>
        )}

        <p className="muted auth-login-footnote">
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
